import type { Mark, TrackPoint } from '../types';

type RenderableMark = Pick<Mark, 'id' | 'lat' | 'lon'>;

export type SelectRenderableMarksOptions = {
  marks: RenderableMark[];
  trackData: TrackPoint[];
  editingRange?: { start: number; end: number } | null;
  loa: number;
  isEditingMarks: boolean;
};

const isValidMark = (mark: RenderableMark): boolean =>
  typeof mark.lat === 'number' &&
  typeof mark.lon === 'number' &&
  Number.isFinite(mark.lat) &&
  Number.isFinite(mark.lon);

export const selectRenderableMarks = ({
  marks,
}: SelectRenderableMarksOptions): RenderableMark[] => {
  return marks.filter((mark) => isValidMark(mark));
};
